import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import { getCurrentMonth, getMyPlanUsage } from "../Usage/usageApi";
import { UsageBar, planLabel } from "../Usage/UsageParts";
import { formatNumber } from "../Usage/usageFormat";

// Small card on the tenant dashboard: this month's usage and a link to
// the Plan & Usage page.
const PlanUsageDashboardCard = () => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    getMyPlanUsage()
      .then(setData)
      .catch(() => setData(null));
  }, []);

  if (!data) return null;
  const thisMonth = data.months.find((m) => m.month === getCurrentMonth());

  return (
    <Card className="mb-4">
      <CardBody className="d-flex flex-wrap align-items-center gap-4">
        <div style={{ minWidth: 200 }}>
          <h5 className="mb-1">{t("usage.dashboardCard.heading")}</h5>
          <p className="text-muted mb-0">{planLabel(t, data.plan)}</p>
        </div>
        <div className="flex-grow-1" style={{ minWidth: 240 }}>
          {thisMonth && data.quota ? (
            <UsageBar
              messageCount={thisMonth.messageCount}
              quota={thisMonth.quota}
              showCounts
            />
          ) : thisMonth ? (
            // No plan yet (phase 1): still show this month's count.
            <span className="fw-semibold fs-15">
              {t("usage.messageCountValue", {
                count: formatNumber(thisMonth.messageCount, i18n.language),
              })}
            </span>
          ) : (
            <span className="text-muted">{t("usage.tenant.planNotSet")}</span>
          )}
        </div>
        <Link to="/plan-usage" className="text-nowrap">
          {t("usage.dashboardCard.viewDetails")}
          <i className="ri-arrow-right-line ms-1 align-middle"></i>
        </Link>
      </CardBody>
    </Card>
  );
};

export default PlanUsageDashboardCard;
